import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  TemplateRef,
} from "@angular/core";
import { AuthService } from "src/app/services/auth.service";
import { HttpClient } from "@angular/common/http";
import {MatPaginator as MatPaginator, PageEvent as PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import {MatTableDataSource as MatTableDataSource,MatTable as MatTable } from "@angular/material/table";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {MatDialog as MatDialog } from "@angular/material/dialog";
import {MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";

import { AdvanceSearchDialogComponent } from "src/app/catalog/advance-search-dialog/advance-search-dialog.component";

export enum AdvanceSearchDialogTypes {
  SubmittedForm = 5,
}
@Component({
  selector: "app-submit-forms",
  templateUrl: "./submit-forms.component.html",
  styleUrls: ["./submit-forms.component.css"],
})
export class SubmitFormsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = [
    "id",
    "formName",
    "mailSender",
    "mailSendStatus",
    "mailReceiver",
    "submitionDate",
    "submitterMailReceiver",
    "submitterMailSendStatus",
    "action",
  ];
  pageSizeOptions: number;
  dataSource = new MatTableDataSource();
  modalRef: BsModalRef;
  index: number = 0;
  size: number = 10;
  dataLength: any;
  formdataarr: any[] = [];
  formdata: any;
  jsonToBeUsed: any[] = [];
  params: any = {};
  fromDate: any;
  toDate: any;
  SendemailStatus: any;
  SubmitterSendemailStatus: any;
  public advanceSearchType = AdvanceSearchDialogTypes.SubmittedForm;

  filterForm = new FormGroup({
    name: new FormControl(""),
    SubmittionDateFrom: new FormControl(""),
    SubmittionDateTo: new FormControl(""),
    SendemailStatus: new FormControl(""),
    SubmitterSendemailStatus: new FormControl(""),
  });
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    private modalservice: BsModalService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getAll();
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  changePage(event: PageEvent) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getAll();
  }
  getAll() {
    this.params = {
      Pagination: { Start: this.index, Number: this.size },
      Search: {
        PredicateObject: {
          SubmittionDate: {
            before: this.filterForm.value.SubmittionDateFrom,
            after: this.filterForm.value.SubmittionDateTo,
          },
          MailSendStatus: this.filterForm.value.SendemailStatus || null,
          SubmitterMailSendStatus:
            this.filterForm.value.SubmitterSendemailStatus || null,
        },
      },
      Sort: {},
    };

    this.httpClient
      .post(`/Forms/getSubmittedForms`, this.params)
      .subscribe((res: any) => {
        this.dataSource = new MatTableDataSource(res.items);
        this.dataLength = res.length;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = (data: any, filtersJson: string) => {
          const matchFilter = [];
          const filters = JSON.parse(filtersJson);

          filters.forEach((filter) => {
            const val = data[filter.id] === null ? "" : data[filter.id];
            matchFilter.push(
              val.toLowerCase().includes(filter.value.toLowerCase())
            );
          });
          return matchFilter.every(Boolean);
        };

        this.formdataarr = res;
      });
  }

  openModal(template: TemplateRef<any>, element) {
    this.formdata = element.formData;
    var json = JSON.parse(this.formdata);
    this.jsonToBeUsed = [];
    for (var type in json) {
      var item = { key: "", value: "" };
      item.key = type;
      item.value = json[type];
      this.jsonToBeUsed.push(item);
    }

    this.modalRef = this.modalservice.show(template, { class: "modal-lg" });
  }

  applyFilter() {
    this.index = 0;
    this.size = 10;
    this.params = {
      Pagination: { Start: 0, Number: 10 },
      Search: {
        PredicateObject:
          {
            SubmittionDate: {
              before: this.filterForm.value.SubmittionDateFrom,
              after: this.filterForm.value.SubmittionDateTo,
            },
            MailSendStatus: this.filterForm.value.SendemailStatus || null,
            SubmitterMailSendStatus:
              this.filterForm.value.SubmitterSendemailStatus || null,
          } || null,
      },
      Sort: {},
    };
    this.getAll();
  }
  openAdvanceSearchDialog() {
    const dialogRef = this.dialog.open(AdvanceSearchDialogComponent, {
      data: { type: this.advanceSearchType },
      width: "700px",
      height: "700px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.filterForm.value.SendemailStatus = result.sendEmailStatus;
        this.filterForm.value.SubmitterSendemailStatus =
          result.submittersendEmailStatus;
        this.filterForm.value.SubmittionDateFrom = result.submitDateFrom;
        this.filterForm.value.SubmittionDateTo = result.submitDateTo;
        this.filterForm.patchValue(result);
        this.applyFilter();
      }
      console.log(`Dialog result: ${result}`);
    });
  }
  public clearFilters() {
    this.filterForm.reset();
    this.applyFilter();
  }
}
